import { render } from "./global-notify.vue?vue&type=template&id=daa0acee"
import script from "./global-notify.vue?vue&type=script&lang=js"
export * from "./global-notify.vue?vue&type=script&lang=js"

import "./global-notify.vue?vue&type=style&index=0&id=daa0acee&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__